// Image configuration for marketing pages
// Replace these URLs with actual image URLs

export const TRYON_PAGE_CONFIG = {
  hero: {
    headline: "See the Fit Before the Checkout",
    subheadline: "High-fidelity virtual try-on that helps customers choose confidently, before they buy.",
    supportingText: "NanoKart.ai lets customers see how a dress looks on their own body, reducing size confusion, hesitation, and returns."
  },
  demo: {
    humanImage: "https://v1-garments.s3.ap-south-1.amazonaws.com/nanokart_ai/20260110203941.webp",
    dressImage: "https://v1-garments.s3.ap-south-1.amazonaws.com/nanokart_ai/20260110204009.webp",
    outputImage: "https://v1-garments.s3.ap-south-1.amazonaws.com/nanokart_ai/20260110204027.webp"
  },
  stats: {
    returnsReduction: "40%"
  }
};

export const MOMENTS_PAGE_CONFIG = {
  hero: {
    headline: "Your Customer Doesn't Buy a Dress.",
    headlineAccent: "They Buy a Moment.",
    subheadline: "Moments show customers how they'll look after buying: at work, at celebrations, or in everyday life."
  },
  baseImage: "https://v1-garments.s3.ap-south-1.amazonaws.com/nanokart_ai/20260110204027.webp",
  moments: {
    creative_workday: {
      label: "Creative Workday",
      description: "Professional yet stylish for the modern workplace",
      image: "https://v1-garments.s3.ap-south-1.amazonaws.com/nanokart_ai/20260110204049.webp"
    },
    unwind: {
      label: "Unwind",
      description: "Relaxed and comfortable for leisure time",
      image: "https://v1-garments.s3.ap-south-1.amazonaws.com/nanokart_ai/20260110204105.webp"
    },
    after_hours: {
      label: "After Hours",
      description: "Glamorous for evening events and parties",
      image: "https://v1-garments.s3.ap-south-1.amazonaws.com/nanokart_ai/20260110204133.webp"
    },
    the_escape: {
      label: "The Escape",
      description: "Perfect for vacation and travel moments",
      image: "https://v1-garments.s3.ap-south-1.amazonaws.com/nanokart_ai/20260110204152.webp"
    },
    gentle_celebration: {
      label: "Gentle Celebration",
      description: "Elegant for special occasions and festivities",
      image: "https://v1-garments.s3.ap-south-1.amazonaws.com/nanokart_ai/20260110204117.webp"
    }
  }
};
